import { axiosInstance } from '@/plugins/axios';

// 餐单接口模块

const action = {
  getMenuById: 'candao.product.getProductMenuByMenuId', //
  getter: 'candao.product.getProductMenu', // 获取餐单信息
  group: 'candao.product.getGroupData', // 获取套餐
  combination: 'candao.product.getProductCombination', // 获取餐品组合
};

// 转换餐品特殊要求数据为提交订单结构
const filterRequirement = (data) => {
  const list = [];
  data.forEach((req) => {
    if (typeof (req.isInited) === 'undefined' || !req.isInited) {
      const propertys = [];
      req.propertys.forEach((property) => {
        const items = [];
        property.items.forEach((item) => {
          if (item.isSelect) {
            items.push({
              isSelect: true,
              uid: item.uid,
              price: item.price,
              name: item.name,
            });
          }
        });
        if (items.length > 0) {
          propertys.push({
            pid: property.uid || property.pid,
            items,
          });
        }
      });
      if (propertys.length > 0) {
        list.push({
          isInited: true,
          index: req.index,
          num: req.num,
          propertys,
        });
      }
    } else if (req.isInited === true) {
      list.push(req);
    }
  });
  return list;
};

const filterCell = (cell) => {
  const product = {
    index: cell.index,
    pid: cell.pid,
    name: cell.name,
    price: cell.price,
    num: cell.num,
  };
  if (typeof cell.itemIndex !== 'undefined') {
    Object.assign(product, {
      itemIndex: cell.itemIndex,
    });
  }

  if (cell.isRequirement) {
    Object.assign(product, {
      listPropertys: filterRequirement(cell.listRequirements).concat([]),
    });
  }
  return product;
};

const filterGroup = (gropusData) => {
  const list = [];
  gropusData.forEach((data, index) => {
    if (typeof (data.isInited) === 'undefined' || !data.isInited) {
      const group = {
        isInited: true,
        index,
        num: data.num,
        mains: [],
        exArea: {},
      };
      // 处理主食区
      if (data.mainFoodAreas && data.mainFoodAreas.length > 0) {
        const mains = [];
        data.mainFoodAreas.forEach((main) => {
          const mid = main.areaId;
          const name = main.title;
          const groups = [];
          if (main.groupA) {
            const area = {
              type: main.groupA.type,
              name: main.groupA.title,
              products: [],
            };
            const selectIndex = main.groupA.index;
            if (main.groupA.cells[selectIndex].isSelected) {
              area.products.push(filterCell(main.groupA.cells[selectIndex]));
            }
            groups.push({ ...area });
          }
          if (main.areas && main.areas.length > 0) {
            const selectIndex = main.groupA ? main.groupA.index : 0;
            Object.keys(main.areas[selectIndex]).forEach((key) => {
              const area = {
                type: main.areas[selectIndex][key].type,
                name: main.areas[selectIndex][key].title,
                products: [],
              };

              if (key === 'groupB') {
                main.areas[selectIndex][key].cells.forEach((cell) => {
                  area.products.push(filterCell(cell));
                });
                // for (const cell of ) {
                //   area.products.push(filterCell(cell));
                // }
              } else if (key === 'groupC') {
                main.areas[selectIndex][key].items.forEach((item) => {
                  if (item.cells[item.selectIndex].isSelected && item.cells[item.selectIndex].pid > 0) {
                    area.products.push(filterCell(item.cells[item.selectIndex]));
                  }
                });
                // for (const item of main.areas[selectIndex][key].items) {
                // }
              } else if (key === 'groupD') {
                main.areas[selectIndex][key].items.forEach((item) => {
                  item.cells.forEach((cell) => {
                    if (cell.num > 0) {
                      area.products.push(filterCell(cell));
                    }
                  });
                });
              }

              groups.push({ ...area });
            });
            // for (const key in main.areas[selectIndex]) {
            // }
          }
          mains.push({
            mid,
            name,
            groups,
          });
        });
        // for (const main of data.mainFoodAreas) {
        // }
        group.mains = mains.concat([]);
      }

      // 处理副食区
      if (data.hasExtArea && data.extFoodArea) {
        const exArea = {
          name: data.extFoodArea.title,
          groups: [],
        };
        const areas = [];
        Object.keys(data.extFoodArea.areas).forEach((key) => {
          const area = {
            name: data.extFoodArea.areas[key].title,
            type: data.extFoodArea.areas[key].type,
            products: [],
          };

          if (key === 'groupB') {
            data.extFoodArea.areas[key].cells.forEach((cell) => {
              area.products.push(filterCell(cell));
            });
          } else if (key === 'groupC') {
            data.extFoodArea.areas[key].items.forEach((item) => {
              if (item.cells[item.selectIndex].isSelected === true && item.cells[item.selectIndex].pid > 0) {
                area.products.push(filterCell(item.cells[item.selectIndex]));
              }
            });
            // for (const item of data.extFoodArea.areas[key].items) {
            // }
          } else if (key === 'groupD') {
            data.extFoodArea.areas[key].items.forEach((item) => {
              item.cells.forEach((cell) => {
                if (cell.num > 0) {
                  area.products.push(filterCell(cell));
                }
              });
            });
          }

          areas.push(area);
        });
        exArea.groups = [...areas];
        group.exArea = JSON.parse(JSON.stringify(exArea));
      }

      list.push(group);
    } else if (data.isInited === true) {
      // 已转换过数据格式
      list.push(data);
    }
  });
  // for (const [index, data] of gropusData.entries()) {
  // }

  return list;
};

const identifyingInGroup = (groups) => {
  const identifying = [];
  groups.forEach((group) => {
    group.mainFoodAreas.forEach((main) => {
      if (main.groupA && main.groupA) {
        main.groupA.cells.forEach((cells) => {
          identifying.push(`${cells.index}`);
        });
      }
      main.areas.forEach((areas) => {
        if (areas.groupB) {
          areas.groupB.cells.forEach((cell) => {
            identifying.push(`${cell.index}${cell.num}`);
          });
        }
        ['groupC', 'groupD'].forEach((key) => {
          if (!areas[key]) {
            return;
          }
          (areas[key].cells || areas[key].items).forEach((items) => {
            identifying.push(`${items.index}`);
            if (key === 'groupC') {
              const filterData = items.cells.filter(cell => cell.isSelected);
              if (filterData.length) {
                identifying.push(`${filterData[0].index}`);
              }
            } else {
              items.cells.forEach((cell) => {
                identifying.push(`${cell.index}${cell.num}`);
              });
            }
          });
        });
      });
    });
    if (group.extFoodArea && group.extFoodArea.areas) {
      if (group.extFoodArea.areas.groupB) {
        group.extFoodArea.areas.groupB.cells.forEach((cell) => {
          identifying.push(`${cell.index}${cell.num}`);
        });
      }
      ['groupC', 'groupD'].forEach((key) => {
        if (!group.extFoodArea.areas[key]) {
          return;
        }
        (group.extFoodArea.areas[key].cells || group.extFoodArea.areas[key].items).forEach((items) => {
          identifying.push(`${items.index}`);
          if (key === 'groupC') {
            const filterData = items.cells.filter(cell => cell.isSelected);
            if (filterData.length) {
              identifying.push(`${filterData[0].index}`);
            }
          } else {
            items.cells.forEach((cell) => {
              identifying.push(`${cell.index}${cell.num}`);
            });
          }
        });
      });
    }
  });
  return identifying;
};

const identifyingInListRequirement = (listRequirements) => {
  const identifying = [];
  listRequirements.forEach((req) => {
    req.propertys.forEach((property, propertyIndex) => {
      property.items.forEach((item, itemIndex) => {
        if (item.isSelect) {
          identifying.push(propertyIndex, itemIndex);
        }
      });
    });
  });
  return identifying;
};


const getIdentifying = (food) => {
  const identifying = [];
  if (food.uid) {
    identifying.push(food.uid);
  }
  switch (food.type) {
    case 1:
      if (food.isRequirement) {
        identifying.push(...identifyingInListRequirement(food.listRequirements));
      }
      break;
    case 2:
      if (food.groups && food.groups.length) {
        identifying.push(...identifyingInGroup(food.groups));
      }
      break;
    default:
      return [];
  }
  return identifying;
};

// 转换餐品数据为提交订单结构
const filterProducts = (data) => {
  const products = [];
  data.forEach((food) => {
    const obj = {
      pid: (food.pid || food.uid),
      typeId: food.typeId,
      num: food.num,
      price: food.price,
      totalPrice: food.totalPrice + (food.requirementPrice || 0) + (food.groupPrice || 0),
    };
    if (Object.prototype.hasOwnProperty.call(food, 'subTotalPrice')) {
      obj.totalPrice = food.subTotalPrice;
    }
    if (food.isRequirement) { // 转换特殊要求数据
      const listRequirements = filterRequirement(food.listRequirements);
      Object.assign(obj, { listRequirements });
    } else if (food.type === 2) {
      Object.assign(obj, {
        groups: filterGroup(food.groups),
      });
    }
    products.push(obj);
  });
  // for (const food of data) {
  // }
  return products;
};

const menu = {
  getIdentifying,
  filterProducts, // 转换餐品数据为提交订单结构 方法
  filterGroup,
  filterRequirement,
  getter: ({ actionName = action.getter, ...data }) => axiosInstance({ // 获取餐单信息
    method: 'post',
    url: 'Action',
    params: {
      method: 'getProductMenu',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  getMenuById: ({ actionName = action.getMenuById, ...data }) => axiosInstance({ // 根据id获取餐单
    method: 'post',
    url: 'Action',
    params: {
      method: 'getProductMenuByMenuId',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  group: ({ actionName = action.group, ...data }) => axiosInstance({ // 获取套餐信息
    method: 'post',
    url: 'Action',
    params: {
      method: 'getGroupData',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  combination: ({ actionName = action.combination, ...data }) => axiosInstance({ // 获取餐品组合信息
    method: 'post',
    url: 'Action',
    params: {
      method: 'getProductCombination',
    },
    data: {
      actionName,
      ...data,
    },
  }),
};

export default menu;
